// extracted by mini-css-extract-plugin
module.exports = {"ORDER_EXAM-form":"ORDER_EXAM-form-3bfd1da336d84bde1e453e5c1af77f57"};